module.exports = __webpack_public_path__ + "img/24db6de.jpg";